import { useEffect } from 'react'

// Observes every [data-reveal] element once and marks it data-revealed when it enters the viewport.
// .reveal-ready is only added after the observer exists, so content is never hidden without JS.
export const useReveal = (): void => {
    useEffect(() => {
        const elements = Array.from(document.querySelectorAll<HTMLElement>('[data-reveal]:not([data-revealed])'))

        if (elements.length === 0) return

        if (typeof IntersectionObserver === 'undefined') {
            elements.forEach(element => element.setAttribute('data-revealed', ''))
            return
        }

        const observer = new IntersectionObserver(entries => {
            for (const entry of entries) {
                if (!entry.isIntersecting) continue

                entry.target.setAttribute('data-revealed', '')
                observer.unobserve(entry.target)
            }
        }, { rootMargin: '0px 0px -6% 0px', threshold: 0.1 })

        document.documentElement.classList.add('reveal-ready')
        elements.forEach(element => observer.observe(element))

        return () => observer.disconnect()
    }, [])
}
